export const catalog = [
  {
    id: "compass",
    name: "Compass rose",
    group: 0,
    graphic: "compass",
    status: "Existing",
    current: "dial → CompassRose; single pointer today",
    bindings: "heading: angle, true or magnetic reference",
    attrs:
      "orientation: north-up|heading-up = north-up; pointer: needle|chevron|tick = needle; ticks: coarse|fine = coarse; center: heading|none = heading; cardinalLabels: boolean = true",
    presets: "Heading · Course over ground · Bearing to waypoint",
    neo: "Show heading in a large compass with fine ticks.",
    refs: ["9.5.35"],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "head-up",
    name: "Heading-up rose",
    group: 0,
    graphic: "headrose",
    status: "Reuse",
    current: "CompassRose supports ringRotation; richer Helm module exists",
    bindings: "heading: angle; course/bearing: optional compatible angles",
    attrs:
      "orientation: heading-up = heading-up; pointers: role/style array ≤6; centerRole: heading|course|speed; sectorArcs: array ≤4; legend: auto|show|hide",
    presets: "Helm · Heading with COG · Waypoint bearing",
    neo: "Keep the bow at the top and show my course as a second pointer.",
    refs: ["9.5.27"],
    workCategory: "Compose existing primitives",
    implementationWork:
      "Compose existing primitives into a registered board component with validated bindings, attributes and presets. Add any required data or action integration named in its bindings.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "wind-rose",
    name: "Combined wind rose",
    group: 0,
    graphic: "wind",
    status: "Existing",
    current:
      "Multi-pointer wind exists inside the composed Underway Helm module",
    bindings:
      "apparentAngle + apparentSpeed; optional trueAngle + trueSpeed with water/ground reference; absolute display also requires a compatible heading/reference binding",
    attrs:
      "frame: relative|absolute = relative; orientation: bow-up|north-up; pointers: role/style/badge array; centerRole: apparentSpeed|trueSpeed; speedLabels: boolean = true; sectors: array ≤4",
    presets:
      "Apparent wind · True-water wind · Apparent + true-water · Apparent + true-ground",
    neo: "Show true and apparent wind, with true wind speed in the center.",
    refs: ["9.5.50"],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions. Make the component independently placeable on owner boards rather than available only within the composed Underway board.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "close-wind",
    name: "Close-hauled wind dial",
    group: 0,
    graphic: "closewind",
    status: "New",
    current: "Needs an expanded-angle scale beyond the current rose",
    bindings: "relative wind angle + speed; explicit wind reference",
    attrs:
      "expandedArc: approved angle interval; scaleMode: close-hauled = close-hauled; tackLabels: boolean = true; targetAngle: optional number; historyTrail: off|short = off",
    presets: "Upwind apparent · Upwind true · Target sailing angle",
    neo: "Give me a close-hauled wind dial with a target angle of 42 degrees.",
    refs: ["9.5.50"],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "wind-angle",
    name: "Relative wind angle",
    group: 0,
    graphic: "relative",
    status: "Existing",
    current: "dial can render relative angles when range.min is negative",
    bindings: "relative angle: port/starboard sign convention",
    attrs:
      "frame: relative = relative; bounds: −180..180; center: angle|speed; portStarboardLabels: boolean = true; targetSectors: optional array",
    presets: "Apparent angle · True angle · Bow-relative bearing",
    neo: "Use a port/starboard wind angle dial instead of compass headings.",
    refs: ["9.5.50"],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "rudder",
    name: "Rudder angle and order",
    group: 0,
    graphic: "rudder",
    status: "Reuse",
    current: "Compose existing gauge/rose marks; add rudder-specific semantics",
    bindings:
      "actualAngle: relative angle; orderedAngle: optional relative angle",
    attrs:
      "bounds: symmetric number pair; zeroLabel: string = centered; showOrder: boolean = true; orderStyle: tick|needle; portStarboardLabels: boolean = true",
    presets: "Actual rudder · Actual versus commanded rudder",
    neo: "Show actual and ordered rudder angles on the same instrument.",
    refs: ["9.5.38"],
    workCategory: "Compose existing primitives",
    implementationWork:
      "Compose existing primitives into a registered board component with validated bindings, attributes and presets. Add any required data or action integration named in its bindings.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "turn-rate",
    name: "Rate of turn",
    group: 0,
    graphic: "turn",
    status: "Reuse",
    current: "A centered gauge can reuse existing chart primitives",
    bindings: "turnRate: signed angular velocity",
    attrs:
      "range: symmetric bounds; unit: compatible angular rate; deadband: nonnegative number; centerMark: boolean = true; pointerStyle: needle|bar",
    presets: "Slow maneuvering · Underway turn rate",
    neo: "Add a centered rate-of-turn gauge in degrees per minute.",
    refs: ["9.5.37"],
    workCategory: "Compose existing primitives",
    implementationWork:
      "Compose existing primitives into a registered board component with validated bindings, attributes and presets. Add any required data or action integration named in its bindings.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "heel",
    name: "Heel and trim indicator",
    group: 0,
    graphic: "heel",
    status: "New",
    current: "Needs a dedicated inclinometer renderer",
    bindings: "roll: angle; pitch: optional angle",
    attrs:
      "axis: roll|pitch|both = roll; scale: symmetric bounds; zeroReference: calibrated source; display: arc|bubble; visualLimit: optional angle",
    presets: "Heel · Trim · Two-axis inclination",
    neo: "Show heel as a simple bubble indicator.",
    refs: ["9.5.28"],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "attitude",
    name: "Attitude indicator",
    group: 0,
    graphic: "attitude",
    status: "New",
    current: "Needs horizon geometry and pitch/roll binding",
    bindings: "roll + pitch: angles; heading: optional angle",
    attrs:
      "horizon: boolean = true; pitchLadder: boolean = true; rollTicks: approved set; centerMarker: fixed; headingStrip: boolean = false",
    presets: "Pitch and roll · Full attitude",
    neo: "Add an attitude instrument with a pitch ladder.",
    refs: ["9.5.9"],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "set-drift",
    name: "Set and drift vector",
    group: 0,
    graphic: "vector",
    status: "Reuse",
    current:
      "Existing Underway set-drift module shows numeric readouts; vector presentation is proposed",
    bindings: "validated set angle + drift speed, with derivation provenance",
    attrs:
      "orientation: north-up|heading-up = north-up; vectorScale: auto|fixed; showReference: boolean = true; showConfidence: boolean = true",
    presets: "Current vector · Course/water-track comparison",
    neo: "Show the current vector and keep its reference visible.",
    refs: [],
    workCategory: "Compose existing primitives",
    implementationWork:
      "Compose existing primitives into a registered board component with validated bindings, attributes and presets. Add any required data or action integration named in its bindings.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "number",
    name: "Numeric readout",
    group: 1,
    graphic: "number",
    status: "Existing",
    current: "tile → Readout; finite numbers only",
    bindings: "value: one numeric path",
    attrs:
      "alignment: start|center|end = start; valueSize: normal|hero; captionPosition: above|below; secondaryRole: optional numeric binding",
    presets: "Depth · Speed · Temperature · Voltage · Pressure",
    neo: "Make depth a large centered number with meters underneath.",
    refs: ["9.5.15", "9.5.16", "9.5.17", "9.5.18", "9.5.19"],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "trend-number",
    name: "Readout with recent trend",
    group: 1,
    graphic: "trendnumber",
    status: "Existing",
    current: "sparkline widget → TrendReadout; fixed 24h today",
    bindings: "value + time-series history of the same measure",
    attrs:
      "historyPlacement: below|behind = below; window: approved history span; extremes: off|window = window; delta: off|absolute|percent; sparkHeight: compact|normal",
    presets: "Battery voltage · Pressure trend · Cabin temperature",
    neo: "Put a six-hour trend beneath the barometer reading.",
    refs: [],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "state",
    name: "State indicator",
    group: 1,
    graphic: "state",
    status: "New",
    current: "Current tile cannot render boolean or enum states",
    bindings: "state: boolean or enum; optional reason/freshness",
    attrs:
      "display: dot|label|symbol; mappings: state→label/tone; unknownLabel: string = unknown; pulse: off = off; showAge: boolean = true",
    presets: "Bilge pump · Door open · Shore power · Device online",
    neo: "Show shore power as a labeled status indicator.",
    refs: ["9.5.29", "9.5.30", "9.5.31"],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "text-value",
    name: "Text readout",
    group: 1,
    graphic: "text",
    status: "New",
    current: "Add string/enum handling beyond numeric Readout",
    bindings: "value: string or named enum",
    attrs:
      "wrap: boolean = false; alignment: start|center; emptyLabel: string = —; maxLines: 1..3 = 1; enumLabels: bounded map",
    presets: "Operating mode · Destination · Device message",
    neo: "Show the active destination as a text instrument.",
    refs: ["9.5.45"],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "multi-text",
    name: "Multi-line data panel",
    group: 1,
    graphic: "multitext",
    status: "New",
    current: "Needs named text/number rows with per-role formatting",
    bindings: "rows: named numeric/text/state roles ≤6",
    attrs:
      "rows: label/role/format array; layout: stacked|two-column; labelWidth: auto; separators: boolean = false; wrap: boolean = true",
    presets: "Position · Trip details · Device diagnostics",
    neo: "Make a compact panel showing latitude, longitude, and time.",
    refs: ["9.5.46"],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "status-strip",
    name: "Status strip",
    group: 1,
    graphic: "statusstrip",
    status: "New",
    current: "Needs a configurable compact collection of state/value roles",
    bindings: "cells: named numeric/state roles; bounded by client width",
    attrs:
      "cells: ordered array; labelMode: short|full; overflow: wrap; includeHealth: boolean; density: compact|comfortable",
    presets: "Engine summary · Helm footer · Power status",
    neo: "Put essential power readings in a compact strip.",
    refs: ["9.5.41", "9.5.42", "9.5.43"],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "counter",
    name: "Event counter",
    group: 1,
    graphic: "counter",
    status: "New",
    current: "Needs durable event-count data and reset authorization",
    bindings: "count: integer; event source + reset capability",
    attrs:
      "countMode: total|period; period: supported enum; digits: auto|1..8; showReset: boolean = false; resetScope: authorized service",
    presets: "Bilge cycles · Pump starts · Door openings",
    neo: "Show today's bilge-pump cycle count.",
    refs: ["9.5.20"],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "timer",
    name: "Elapsed-time instrument",
    group: 1,
    graphic: "timer",
    status: "New",
    current: "Needs a timer source or durable event-state derivation",
    bindings: "duration: time; optional running state + reset capability",
    attrs:
      "mode: elapsed|remaining; format: auto|hh:mm:ss; period: total|session; showRunningState: boolean = true; reset: capability-gated",
    presets: "Engine running time · Pump duration · Service countdown",
    neo: "Show how long the generator has been running.",
    refs: ["9.5.48"],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "analog-clock",
    name: "Analog clock",
    group: 1,
    graphic: "clock",
    status: "New",
    current: "New clock renderer; time must name its source",
    bindings: "time: platform or vessel time",
    attrs:
      "zone: account|UTC|named zone; secondHand: boolean = false; labels: cardinal|all; format: 12-hour = 12-hour; sourceLabel: boolean = true",
    presets: "Local time · UTC · Vessel time",
    neo: "Add a small analog UTC clock.",
    refs: ["9.5.7"],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "digital-clock",
    name: "Digital clock and date",
    group: 1,
    graphic: "digitalclock",
    status: "Reuse",
    current: "Compose text/readout styling with platform time",
    bindings: "time + optional date",
    attrs:
      "zone: account|UTC|named zone; format: 12h|24h = 24h; seconds: boolean = false; date: boolean = true",
    presets: "UTC time · Local date and time",
    neo: "Show local time in 24-hour format with the date.",
    refs: [],
    workCategory: "Compose existing primitives",
    implementationWork:
      "Compose existing primitives into a registered board component with validated bindings, attributes and presets. Add any required data or action integration named in its bindings.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "arc-gauge",
    name: "Arc gauge",
    group: 2,
    graphic: "gauge",
    status: "Existing",
    current: "gauge → ArcGauge; zones/markers are not yet board options",
    bindings: "value: numeric; optional reference value",
    attrs:
      "min/max: numbers; sweep: approved arc preset; zones: value intervals; referenceMarker: optional number/role; tickLabels: boolean; showValue: boolean = true",
    presets: "RPM · Boat speed · Charging rate · Temperature",
    neo: "Use an RPM gauge with a maximum marker and an operating zone.",
    refs: ["9.5.24", "9.5.25"],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "needle-gauge",
    name: "Needle gauge",
    group: 2,
    graphic: "needle",
    status: "Reuse",
    current:
      "Gauge geometry exists; full needle-face variant needs composition",
    bindings: "value: numeric",
    attrs:
      "range: fixed bounds; sweep: full|three-quarter|half; ticks: approved divisions; zones: bounded intervals; valuePosition: center|below",
    presets: "Oil pressure · Coolant temperature · DC voltage",
    neo: "Show oil pressure as a classic needle gauge.",
    refs: ["9.5.24", "9.5.25"],
    workCategory: "Compose existing primitives",
    implementationWork:
      "Compose existing primitives into a registered board component with validated bindings, attributes and presets. Add any required data or action integration named in its bindings.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "vacuum",
    name: "Vacuum gauge",
    group: 2,
    graphic: "vacuum",
    status: "Reuse",
    current: "Gauge preset with pressure/vacuum semantics",
    bindings: "pressure: numeric with absolute/gauge/vacuum reference",
    attrs:
      "unit: compatible pressure unit; direction: validated convention; range: fixed bounds; serviceMarker: optional number; referenceLabel: boolean = true",
    presets: "Fuel-filter vacuum · Intake vacuum",
    neo: "Add a fuel-filter vacuum gauge with a service marker.",
    refs: ["9.5.49"],
    workCategory: "Compose existing primitives",
    implementationWork:
      "Compose existing primitives into a registered board component with validated bindings, attributes and presets. Add any required data or action integration named in its bindings.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "vertical-meter",
    name: "Vertical level meter",
    group: 2,
    graphic: "vertical",
    status: "Reuse",
    current:
      "Current LevelMeter is horizontal; vertical presentation needs a variant",
    bindings: "value: numeric; capacity/range: known quantity",
    attrs:
      "orientation: vertical = vertical; bounds: fixed; direction: highGood|lowGood|neutral; thresholds: labeled values; ticks: approved set; showPercent: boolean",
    presets: "Tank level · State of charge · Load",
    neo: "Make fuel a vertical level meter with a low-level marker.",
    refs: ["9.5.10"],
    workCategory: "Compose existing primitives",
    implementationWork:
      "Compose existing primitives into a registered board component with validated bindings, attributes and presets. Add any required data or action integration named in its bindings.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "horizontal-meter",
    name: "Horizontal bar meter",
    group: 2,
    graphic: "horizontal",
    status: "Existing",
    current: "level → horizontal LevelMeter; rich bar options remain proposed",
    bindings: "value: numeric + range/capacity",
    attrs:
      "orientation: horizontal = horizontal; valuePosition: inline|above; endpoints: boolean = true; targetMarker: optional number; fillDirection: forward|reverse",
    presets: "Battery charge · Generator load · Tank capacity",
    neo: "Use a horizontal bar for generator load.",
    refs: ["9.5.11"],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "borderless-bar",
    name: "Overlay bar meter",
    group: 2,
    graphic: "overlaybar",
    status: "Reuse",
    current: "Add a borderless level preset for diagrams and compact rows",
    bindings: "value: numeric + range/capacity",
    attrs:
      "orientation: horizontal|vertical; track: subtle|none; labels: value|percent|none; background: inherit|transparent; fillDirection: forward|reverse",
    presets: "Diagram tank fill · Minimal capacity bar",
    neo: "Put a minimal fuel-level bar alongside the fuel-system diagram.",
    refs: ["9.5.11"],
    workCategory: "Compose existing primitives",
    implementationWork:
      "Compose existing primitives into a registered board component with validated bindings, attributes and presets. Add any required data or action integration named in its bindings.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "tank",
    name: "Tank silhouette",
    group: 2,
    graphic: "tank",
    status: "Reuse",
    current: "LevelMeter data; new tank silhouette presentation",
    bindings: "level + capacity; optional quantity + fluid identity",
    attrs:
      "shape: rectangle|cylinder|approved asset; display: percent|quantity|both; lowMarker: optional quantity; fluidLabel: boolean = true; fillDirection: bottom-up",
    presets: "Fuel · Fresh water · Waste · Livewell",
    neo: "Show freshwater as a tank with liters and percent.",
    refs: ["9.5.44"],
    workCategory: "Compose existing primitives",
    implementationWork:
      "Compose existing primitives into a registered board component with validated bindings, attributes and presets. Add any required data or action integration named in its bindings.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "sparkline",
    name: "Sparkline",
    group: 3,
    graphic: "spark",
    status: "Existing",
    current: "Sparkline primitive; board sparkline normally includes a value",
    bindings: "time-series: one numeric measure",
    attrs:
      "window: supported span; curve: smooth|linear|step; extremes: off|window; baseline: off|zero|reference; endpointLabel: boolean = false",
    presets: "Recent temperature · Voltage history · Depth strip",
    neo: "Add a compact depth sparkline.",
    refs: [],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "history",
    name: "History line graph",
    group: 3,
    graphic: "line",
    status: "Existing",
    current: "chart + trend chart → HistoryChart",
    bindings:
      "time-series: one or more numeric roles, grouped by compatible unit",
    attrs:
      "window/rolling: approved values; curve: smooth|linear|step; domain: auto|zero|fixed; envelope: boolean; thresholds/markers: arrays; legend: auto|show|hide",
    presets: "Temperature · Voltage · Pressure · Engine readings",
    neo: "Chart battery voltage for seven days and mark the daily minimum.",
    refs: ["9.5.33"],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "depth-graph",
    name: "Depth graph",
    group: 3,
    graphic: "depth",
    status: "Reuse",
    current: "HistoryChart can form the base; add depth-axis convention",
    bindings: "depth time-series with below-keel/transducer/surface reference",
    attrs:
      "axisDirection: deeper-down = deeper-down; window: supported span; shallowLimit: visual value; referenceLabel: boolean = true; bottomFill: boolean = false",
    presets: "Depth below keel · Depth below transducer",
    neo: "Show depth below the keel with deeper water lower on the graph.",
    refs: ["9.5.33"],
    workCategory: "Compose existing primitives",
    implementationWork:
      "Compose existing primitives into a registered board component with validated bindings, attributes and presets. Add any required data or action integration named in its bindings.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "state-history",
    name: "State timeline",
    group: 3,
    graphic: "statehistory",
    status: "New",
    current: "Needs state history query + interval renderer",
    bindings: "state time-series: boolean or enum",
    attrs:
      "states: label/tone map; window: supported span; lanes: named roles ≤6; unknownIntervals: visible; eventMarkers: boolean = true",
    presets: "Pump activity · Shore-power outages · Door history",
    neo: "Show when the bilge pump was on over the last day.",
    refs: ["9.5.33"],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "comparison-bars",
    name: "Comparison bar graph",
    group: 3,
    graphic: "bars",
    status: "Existing",
    current: "bars chart + BarChart; engine hours/voyage distance today",
    bindings: "categories + numeric magnitude; common dimension",
    attrs:
      "orientation: vertical|horizontal; sort: natural|value; baseline: zero; partialPeriods: visible; labels: auto|show; period: supported grouping",
    presets: "Daily engine hours · Voyage distance · Consumption by tank",
    neo: "Compare port and starboard engine running hours this week.",
    refs: [],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "multi-graph",
    name: "Aligned graph panels",
    group: 3,
    graphic: "multipanel",
    status: "Existing",
    current: "chart widget already separates incompatible units",
    bindings: "named time-series roles with individual dimensions",
    attrs:
      "sharedTimeAxis: boolean = true; panelOrder: ordered role list; domains: per-panel; legend: auto; cursor: shared; limit: supported series count",
    presets: "Engine vitals history · Weather dashboard · Power history",
    neo: "Put temperature and pressure in aligned panels with the same time axis.",
    refs: [],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "anchor",
    name: "Anchor-watch plot",
    group: 4,
    graphic: "anchor",
    status: "Existing",
    current: "anchor-watch module on general boards; anchor card also exists",
    bindings: "real anchor position + vessel positions + anchor-watch service",
    attrs:
      "radius: 5..4000 m; trackHours: 1..72; showVessels: boolean; weatherLayers: supported layer set; orientation: north-up|heading-up",
    presets: "Swing circle · Swing history · Anchor with nearby vessels",
    neo: "Show the last six hours of swing and nearby vessels.",
    refs: ["9.5.8"],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "gps",
    name: "GNSS status panel",
    group: 4,
    graphic: "gps",
    status: "New",
    current: "Needs receiver diagnostics roles and status layout",
    bindings: "fix quality + satellite count + optional dilution/accuracy",
    attrs:
      "fields: supported diagnostics list; detail: compact|full; receiverLabel: boolean = true; satelliteView: none|bars|sky when supported",
    presets: "Fix quality · GNSS diagnostics",
    neo: "Add a panel for GPS fix quality and satellite count.",
    refs: ["9.5.26"],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "signal",
    name: "Signal-strength meter",
    group: 4,
    graphic: "signal",
    status: "New",
    current: "Needs signal-quality binding and meter variant",
    bindings: "signal strength with dBm/quality semantics + connection state",
    attrs:
      "display: bars|number|both; scale: source-specific bounds; linkLabel: boolean = true; unknownState: visible; history: optional",
    presets: "Cellular · Wi-Fi · Gateway link",
    neo: "Show the cellular link's signal strength and connection state.",
    refs: ["9.5.40"],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "board-health",
    name: "Board health summary",
    group: 4,
    graphic: "health",
    status: "New",
    current:
      "Compose factual state from included controls; no general health instrument yet",
    bindings: "health states + freshness of declared board members",
    attrs:
      "include: selected item IDs; modeScope: all|current; severityOrder: platform-defined; missingPolicy: visible; drilldown: boolean = true",
    presets: "Engine board health · Power board health · Whole board",
    neo: "Show which instruments on this board need attention.",
    refs: ["9.5.39"],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "traffic",
    name: "AIS traffic plot/list",
    group: 4,
    graphic: "traffic",
    status: "Existing",
    current: "nearby-vessels on general boards; traffic on composed Underway",
    bindings: "real AIS targets + own position + validated target calculations",
    attrs:
      "maxTargets: 1..20; view: list|relative plot; photos: boolean; radius: supported distance; sort: range|risk; labelFields: approved set",
    presets: "Nearby boats · Underway traffic · Closest targets",
    neo: "Show the closest five AIS vessels with their names.",
    refs: [],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "route",
    name: "Route and waypoint view",
    group: 4,
    graphic: "route",
    status: "New",
    current:
      "route-map and passage are declared, capability-suppressed, without web renderer",
    bindings:
      "active route + waypoints + position; optional route navigation metrics",
    attrs:
      "orientation: north-up|heading-up; showTrack: boolean; view: map|leg list; fields: distance/bearing/ETA when available; mapLayers: approved set",
    presets: "Active leg · Route overview · Passage summary",
    neo: "Show the active route and distance to the next waypoint.",
    refs: [],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "forecast",
    name: "Forecast panel",
    group: 4,
    graphic: "forecast",
    status: "Existing",
    current: "forecast module on general boards",
    bindings: "position-grounded forecast service with issued/valid times",
    attrs:
      "hours: 3..48; showSeaState: boolean; fields: supported forecast roles; layout: hourly|summary; showIssuedAt: boolean = true",
    presets: "Wind forecast · Weather summary · Sea-state outlook",
    neo: "Show a 12-hour wind forecast with sea state.",
    refs: [],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "tide",
    name: "Tide graph",
    group: 4,
    graphic: "tide",
    status: "Existing",
    current:
      "General-board tide module shows modeled movement, not absolute height or a station tide table",
    bindings:
      "modeled relative movement today; future station/datum series must declare its actual source",
    attrs:
      "lookbackHours: 3..24; minRangeMeters: 0..3; showExtrema: boolean; datumLabel: boolean = true; stationLabel: boolean = true",
    presets: "Modeled tide movement · Future sourced station tide",
    neo: "Show today's tide with the next high and low.",
    refs: [],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "moon",
    name: "Moon-phase instrument",
    group: 4,
    graphic: "moon",
    status: "New",
    current: "Needs astronomical data/calculation + renderer",
    bindings: "time + observer context when needed",
    attrs:
      "display: phase|illumination|both; hemisphere: source-derived; date: optional selected time; riseSet: capability-dependent; labels: boolean = true",
    presets: "Current phase · Moon illumination",
    neo: "Add the moon phase and illumination percentage.",
    refs: ["9.5.34"],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "pressure",
    name: "Barometer and tendency",
    group: 4,
    graphic: "pressure",
    status: "Existing",
    current: "pressure module on general boards",
    bindings: "pressure + same-source history",
    attrs:
      "window: supported span; tendency: measured delta; showHistory: boolean = true; units: inherited pressure; extrema: off|window",
    presets: "Barometric pressure · Weather tendency",
    neo: "Show pressure and its measured change over three hours.",
    refs: [],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "action",
    name: "Action button",
    group: 5,
    graphic: "button",
    status: "Device",
    current: "Needs registered action routing and feedback",
    bindings: "action ID + target capability; optional result/state",
    attrs:
      "label: string; action: registry-defined; style: filled|quiet; icon: approved token; confirmation: action policy; failureFeedback: visible",
    presets:
      "Open system details · Acknowledge permitted alert · Device action",
    neo: "Add a button that opens the engine details.",
    refs: ["9.5.36"],
    workCategory: "Integrate device commands and feedback",
    implementationWork:
      "Integrate compatible-device capabilities, typed commands, confirmed feedback and permissions, then implement the configurable control.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "active-button",
    name: "State-aware action button",
    group: 5,
    graphic: "activebutton",
    status: "Device",
    current: "Needs current-state feedback separated from command intent",
    bindings: "state + registered command/action + target device",
    attrs:
      "stateLabels: bounded map; style: standard|quiet|overlay; size: approved aspect; pendingState: visible; unavailableState: disabled with reason",
    presets: "Pump on/off · Shore-power detail · System launch",
    neo: "Show a pump button with its confirmed running state.",
    refs: ["9.5.1", "9.5.2", "9.5.3", "9.5.4", "9.5.5"],
    workCategory: "Integrate device commands and feedback",
    implementationWork:
      "Integrate compatible-device capabilities, typed commands, confirmed feedback and permissions, then implement the configurable control.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "rocker",
    name: "Breaker or rocker switch",
    group: 5,
    graphic: "rocker",
    status: "Device",
    current:
      "Needs switching/breaker integration; stereo command paths are not a generic switch API",
    bindings:
      "breaker/switch identity + state + supported commands + fault state",
    attrs:
      "orientation: horizontal|vertical; positions: device-declared; labels: ordered string list; tripState: visible; commandFeedback: required",
    presets: "Cabin lighting · Bilge pump · DC circuit",
    neo: "Put the cabin lighting circuit on the board as a rocker switch.",
    refs: ["9.5.12", "9.5.13"],
    workCategory: "Integrate device commands and feedback",
    implementationWork:
      "Integrate compatible-device capabilities, typed commands, confirmed feedback and permissions, then implement the configurable control.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "vertical-switch",
    name: "Vertical switch",
    group: 5,
    graphic: "verticalswitch",
    status: "Device",
    current: "Same typed switching capability, with a vertical presentation",
    bindings: "switch identity + confirmed state + supported commands",
    attrs:
      "orientation: vertical = vertical; positions: device-declared; labelPosition: above|beside; stateStyle: text|indicator; momentary: device-defined",
    presets: "On/off switch · Device mode selector",
    neo: "Use a vertical on/off switch for the cockpit light.",
    refs: ["9.5.14"],
    workCategory: "Integrate device commands and feedback",
    implementationWork:
      "Integrate compatible-device capabilities, typed commands, confirmed feedback and permissions, then implement the configurable control.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "momentary",
    name: "Momentary pushbutton",
    group: 5,
    graphic: "push",
    status: "Device",
    current: "Needs device-declared momentary command semantics",
    bindings: "momentary action + target; optional feedback",
    attrs:
      "activation: device policy; label/icon: approved values; pressDuration: device-defined; backlight: off|state; confirmation: action policy",
    presets: "Horn · Reset counter · Device-specific command",
    neo: "Add the device's supported reset control with a clear label.",
    refs: ["9.5.36"],
    workCategory: "Integrate device commands and feedback",
    implementationWork:
      "Integrate compatible-device capabilities, typed commands, confirmed feedback and permissions, then implement the configurable control.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "dimmer",
    name: "Light dimmer",
    group: 5,
    graphic: "dimmer",
    status: "Device",
    current: "Needs lighting capability and intensity feedback",
    bindings: "light identity + intensity + on/off + dimming command",
    attrs:
      "display: slider|two-button|three-button; step: device-supported; showPercent: boolean = true; minimum: device limit; offBehavior: declared policy",
    presets: "Cabin lights · Cockpit lights · Courtesy lights",
    neo: "Add a cabin-light dimmer showing its actual brightness.",
    refs: ["9.5.21", "9.5.22"],
    workCategory: "Integrate device commands and feedback",
    implementationWork:
      "Integrate compatible-device capabilities, typed commands, confirmed feedback and permissions, then implement the configurable control.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "lighting-color",
    name: "Color lighting and beam",
    group: 5,
    graphic: "lightbeam",
    status: "Device",
    current: "Needs color-capable lighting integration",
    bindings: "light/zone + intensity + color + supported commands",
    attrs:
      "beamShape: up|down|left|right|circle; display: beam|palette; colorMode: device-declared; showIntensity: boolean; diagramPlacement: approved layout",
    presets: "RGB cabin zone · Courtesy-light beam · Deck lights",
    neo: "Show the deck lights as beams on the boat diagram.",
    refs: ["9.5.32"],
    mconnect: "1.2.0 service bulletin: color/intensity lighting",
    workCategory: "Integrate device commands and feedback",
    implementationWork:
      "Integrate compatible-device capabilities, typed commands, confirmed feedback and permissions, then implement the configurable control.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "climate",
    name: "Climate controller",
    group: 5,
    graphic: "climate",
    status: "Device",
    current:
      "Needs HVAC integration; temperature sensors alone are insufficient",
    bindings: "zone + temperature + setpoint + mode + fan + allowed commands",
    attrs:
      "fields: supported role list; setpointStep: device-declared; bounds: device limits; layout: compact|full; showMode/Fan: boolean",
    presets: "Salon HVAC · Cabin heating · Multi-zone climate",
    neo: "Add salon climate with temperature, setpoint, and fan mode.",
    refs: ["9.5.6"],
    workCategory: "Integrate device commands and feedback",
    implementationWork:
      "Integrate compatible-device capabilities, typed commands, confirmed feedback and permissions, then implement the configurable control.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "ice-maker",
    name: "Ice-maker controller",
    group: 5,
    graphic: "ice",
    status: "Device",
    current: "Needs a compatible device adapter",
    bindings: "device + operating state + available commands/diagnostics",
    attrs:
      "fields: adapter-declared; commands: capability-gated; view: compact|full; showFaults: boolean = true; deviceLabel: boolean = true",
    presets: "Ice-maker state · Ice-maker controls",
    neo: "Show the ice maker's status and supported controls.",
    refs: ["9.5.23"],
    workCategory: "Integrate device commands and feedback",
    implementationWork:
      "Integrate compatible-device capabilities, typed commands, confirmed feedback and permissions, then implement the configurable control.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "watermaker",
    name: "Watermaker controller",
    group: 5,
    graphic: "watermaker",
    status: "Device",
    current:
      "Water budget exists; watermaker command integration requires a device adapter",
    bindings: "device state + production/quality + supported commands",
    attrs:
      "fields: adapter-declared; units: inherited; view: compact|full; showQuality: boolean = true; commandFeedback: required",
    presets: "Production and salinity · Watermaker controls",
    neo: "Add watermaker production, water quality, and permitted controls.",
    refs: ["9.5.52"],
    workCategory: "Integrate device commands and feedback",
    implementationWork:
      "Integrate compatible-device capabilities, typed commands, confirmed feedback and permissions, then implement the configurable control.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "stereo",
    name: "Audio and zone controls",
    group: 5,
    graphic: "stereo",
    status: "Existing",
    current: "stereo module on general boards; capability-gated",
    bindings: "audio service + actual zones + playback state",
    attrs:
      "zones: 1..4; nowPlaying: boolean; volumeControls: compact|full; layout: compact|full; sourceSelector: supported sources only",
    presets: "Now playing · Salon audio · Multi-zone volume",
    neo: "Show now playing and volume for the salon and cockpit.",
    refs: [],
    mconnect: "Manual 1.2.0: multimedia integration",
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "mode",
    name: "Boat-mode selector",
    group: 5,
    graphic: "mode",
    status: "Reuse",
    current:
      "Current web mode card is read-only status; selector needs mode-transition integration",
    bindings: "current mode + supported transitions + transition constraints",
    attrs:
      "visibleModes: supported subset; display: segmented|menu; showReason: boolean = true; commandPolicy: platform-defined",
    presets: "Docked/underway/anchored · Supported boat modes",
    neo: "Add a compact boat-mode selector.",
    refs: [],
    workCategory: "Compose existing primitives",
    implementationWork:
      "Compose existing primitives into a registered board component with validated bindings, attributes and presets. Add any required data or action integration named in its bindings.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "alerts",
    name: "Alert list and status",
    group: 5,
    graphic: "alerts",
    status: "New",
    current:
      "Existing alarm services can supply data; needs a configurable general-board control",
    bindings: "real active alarms + severity + acknowledgment policy",
    attrs:
      "severity/categoryFilters: approved set; order: severity|time; maxRows: bounded integer; showAck: capability-gated; staleState: visible",
    presets: "Critical alerts · Engine alerts · All active alerts",
    neo: "Keep active engine alerts visible on the engine board.",
    refs: [],
    system: "N2KView §10",
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "watchkeeping",
    name: "Watchkeeping timer",
    group: 5,
    graphic: "watch",
    status: "New",
    current:
      "Requires a real watchkeeping workflow; a visual countdown is insufficient",
    bindings: "watchkeeping service + timer state + acknowledgment permissions",
    attrs:
      "display: countdown|state; warningPhases: service-defined; acknowledge: capability-gated; escalation: service-defined; settings: service policy",
    presets: "Watch countdown · Watchkeeping status",
    neo: "Show the watchkeeping service's countdown and current state.",
    refs: [],
    system: "N2KView §11",
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "notification",
    name: "Notification action/status",
    group: 5,
    graphic: "notification",
    status: "New",
    current: "Needs a registered notification action and delivery status",
    bindings:
      "notification capability + permitted destination + delivery state",
    attrs:
      "destination: approved ID; template: registered ID; trigger: explicit action; deliveryFeedback: visible; confirmation: action policy",
    presets: "Send approved notification · Delivery state",
    neo: "Show delivery status for the configured alert notification.",
    refs: ["9.5.47"],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "camera",
    name: "Camera view",
    group: 6,
    graphic: "camera",
    status: "Device",
    current: "Needs authenticated camera/media integration",
    bindings: "camera ID + stream capability + availability",
    attrs:
      "aspect: 4:3|16:9|source; fit: contain|cover; showName/Time: boolean; border: normal|none; fullscreen: boolean = true",
    presets: "Engine room · Stern · Dock camera",
    neo: "Put the engine-room camera on the board in 16:9.",
    refs: ["9.5.51"],
    workCategory: "Integrate device commands and feedback",
    implementationWork:
      "Integrate compatible-device capabilities, typed commands, confirmed feedback and permissions, then implement the configurable control.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "camera-ptz",
    name: "Camera with PTZ",
    group: 6,
    graphic: "ptz",
    status: "Device",
    current: "Adds camera-declared motion controls to media integration",
    bindings: "camera stream + supported pan/tilt/zoom commands",
    attrs:
      "controls: permitted PTZ subset; presets: device-defined positions; speed: supported levels; feedback: required; aspect: source|4:3|16:9",
    presets: "Maneuvering camera · Thermal camera controls",
    neo: "Show the stern camera with its supported pan and zoom controls.",
    refs: ["9.5.51"],
    workCategory: "Integrate device commands and feedback",
    implementationWork:
      "Integrate compatible-device capabilities, typed commands, confirmed feedback and permissions, then implement the configurable control.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "web-page",
    name: "Embedded web panel",
    group: 6,
    graphic: "web",
    status: "New",
    current: "Requires client-supported embedding and allowed source routing",
    bindings: "approved URL/source ID",
    attrs:
      "source: approved URL; aspect: family-approved; title: string; navigation: supported policy; unavailableFallback: named state",
    presets: "Device web interface · Approved external dashboard",
    neo: "Add the approved onboard device web panel.",
    refs: [],
    mconnect: "1.2.0 service bulletin: web-page display",
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "diagram",
    name: "Boat or system diagram",
    group: 6,
    graphic: "diagram",
    status: "New",
    current: "Needs diagram assets + anchored overlays using existing controls",
    bindings: "approved image/vector asset + named data/state overlay roles",
    attrs:
      "asset: approved ID; overlays: normalized anchor/role/control array; labels: boolean; fit: contain; actions: declared capability IDs",
    presets: "Electrical system · Tanks · Lighting plan · Machinery",
    neo: "Show tank levels and pump states on the boat diagram.",
    refs: [],
    mconnect: "Manual 1.2.0: custom graphics",
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "note",
    name: "Label and instruction block",
    group: 6,
    graphic: "note",
    status: "New",
    current: "Owner text exists as item labels; no standalone text-layout item",
    bindings: "owner-authored text; optional procedure ID",
    attrs:
      "content: bounded plain text; style: label|heading|note; alignment: start|center; wrap: boolean = true; procedureLink: optional approved ID",
    presets: "Board heading · Operating note · Procedure link",
    neo: "Add a note identifying the freshwater system.",
    refs: ["9.5.45", "9.5.46"],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "divider",
    name: "Spacer and section divider",
    group: 6,
    graphic: "divider",
    status: "New",
    current: "Requires a layout item rather than telemetry widget",
    bindings: "none",
    attrs:
      "style: space|line|heading; size: responsive spacing token; label: optional string; visibility: client-layout policy",
    presets: "Engine section · Power section · Quiet spacing",
    neo: "Separate port and starboard instruments with section labels.",
    refs: [],
    workCategory: "Build renderer and data support",
    implementationWork:
      "Implement the renderer and any required data or query support, then register its bindings, configuration and initial presets.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "power-budget",
    name: "Battery and power budget",
    group: 7,
    graphic: "battery",
    status: "Existing",
    current:
      "power-budget module on general boards; reserves on composed Underway",
    bindings:
      "real house-bank model + state of charge/current/voltage + provenance",
    attrs:
      "houseBankId: accepted bank ID; concernSoc: 20..80%; fields: supported set; history: supported window; estimates: labeled with confidence",
    presets: "House bank · Charging · Power reserve",
    neo: "Show the house bank with a concern marker at 40 percent.",
    refs: [],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "engine-vitals",
    name: "Engine-vitals panel",
    group: 7,
    graphic: "engine",
    status: "Existing",
    current:
      "engine-vitals module on composed Underway; not yet arbitrary owner boards",
    bindings:
      "engine identity + RPM/temperature/pressure + accepted probe roles",
    attrs:
      "engineIds: accepted IDs; probeKeys: opaque accepted keys ≤8; fields: supported roles; arrangement: paired|stacked; health: factual",
    presets: "Port engine · Starboard engine · Twin-engine comparison",
    neo: "Make a twin-engine panel with RPM, coolant temperature, and oil pressure.",
    refs: [],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions. Make the component independently placeable on owner boards rather than available only within the composed Underway board.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "tanks-budget",
    name: "Tank and reserve panel",
    group: 7,
    graphic: "tanks",
    status: "Existing",
    current:
      "tanks-budget module on general boards; reserves on composed Underway",
    bindings:
      "real tank model + capacity/level/quantity + consumption when supported",
    attrs:
      "prominentTanks: accepted tank IDs ≤8; sort: system|name|remaining; display: percent|quantity|both; forecast: supported model with provenance",
    presets: "Fuel reserves · Water reserves · All tanks",
    neo: "Show fuel and freshwater first, with quantities and percentages.",
    refs: [],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "water-budget",
    name: "Water budget and production",
    group: 7,
    graphic: "waterbudget",
    status: "Existing",
    current:
      "water card shows tank quantities/levels and a server estimate; production readout is a proposed extension",
    bindings:
      "water budget service + tanks + consumption/production where available",
    attrs:
      "fields: supported measures; horizon: service-supported; units: inherited volume; estimateLabels: required; detail: compact|full",
    presets: "Freshwater budget · Consumption versus production",
    neo: "Show our freshwater budget and available production information.",
    refs: [],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "depth-safety",
    name: "Depth-safety panel",
    group: 7,
    graphic: "depthsafe",
    status: "Existing",
    current:
      "depth-safety module on composed Underway; no general-grid renderer",
    bindings: "actual depth with reference + vessel safety model",
    attrs:
      "referenceLabel: required; visualScale: auto|fixed; trend: off|short; thresholdDisplay: labeled; operationalThreshold: service-owned",
    presets: "Under-keel clearance · Shallow-water attention",
    neo: "Keep depth reference and the actual safety threshold visible.",
    refs: [],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions. Make the component independently placeable on owner boards rather than available only within the composed Underway board.",
    implementationPass: 1,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "environment",
    name: "Environment overview",
    group: 7,
    graphic: "environment",
    status: "Existing",
    current:
      "environment-outlook on general boards uses onboard sensors; forecast is a separate module",
    bindings:
      "actual onboard environment readings; future outlook data must declare its source",
    attrs:
      "fields: available role set; layout: compact|full; order: supported role list; provenanceLabels: required; units: inherited",
    presets: "Wind and weather · Cabin environment · Outdoor environment",
    neo: "Show wind, air temperature, and pressure together.",
    refs: [],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
  {
    id: "changes",
    name: "Recent-changes panel",
    group: 7,
    graphic: "changes",
    status: "Existing",
    current: "changes module on composed Underway; no general-grid renderer",
    bindings: "measured recent-change service with source and time",
    attrs:
      "lookbackMinutes: 5..60; fields: accepted role set; sort: service-supported; maxRows: bounded; freshness: visible",
    presets: "Recent underway changes · Engine changes",
    neo: "Show the last 20 minutes of meaningful changes.",
    refs: [],
    workCategory: "Extend existing renderer or module",
    implementationWork:
      "Expose the existing renderer or module as a configurable board component and implement the listed attribute and preset extensions. Make the component independently placeable on owner boards rather than available only within the composed Underway board.",
    implementationPass: 2,
    requiredClients: ["web", "ios"],
    agentEditableFields:
      "Every declared configurable field, using the same validator as the direct editor.",
    customizationScopes: ["panel", "boat"],
    customizationOwnership:
      "Authenticated account plus boat; private overlays never change another user.",
    releaseRequirement:
      "Same appearance, options and behavior verified on both clients.",
  },
];
